export const statusLevel = {
  ERROR: 'error',
  WARN: 'warn',
  PENDING: 'pending',
  OK: 'ok',
};

export const statusType = {
  ORDER: 'order',
  SHIPPING: 'shipping',
  PAYMENT: 'payment',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
};

export const statusExtra = {
  [statusType.SHIPPING]: {
    CREATED: {
      level: statusLevel.OK,
    },
    PACKAGING: {
      level: statusLevel.PENDING,
    },
    SHIPPED: {
      level: statusLevel.OK,
    },
    DELIVERED: {
      level: statusLevel.OK,
    },
    RETURNED: {
      level: statusLevel.OK,
    },
    'RETURNED-COURIER': {
      level: statusLevel.OK,
    },
    'RETURNED-CUSTOMER': {
      level: statusLevel.OK,
    },
    'RETURNED-DECLARED': {
      level: statusLevel.OK,
    },
    BLOCKED: {
      level: statusLevel.ERROR,
    },
  },
  [statusType.PAYMENT]: {
    PAID: {
      level: statusLevel.OK,
    },
    NOT_PAID: {
      level: statusLevel.ERROR,
    },
    CHARGEBACK: {
      level: statusLevel.ERROR,
    },
    REJECTED: {
      level: statusLevel.ERROR,
    },
    REFUND: {
      level: statusLevel.OK,
    },
  },
  [statusType.ORDER]: {
    SUSPENDED: {
      level: statusLevel.ERROR,
    },
    RUNNING: {
      level: statusLevel.OK,
    },
    CANCELLED: {
      level: statusLevel.ERROR,
    },
    DISCARDED: {
      level: statusLevel.ERROR,
    },
  },
};
export const whatsAppSupport = {
  uk: {
    FH: '447700155872',
    PW: '447700155872',
  },
  de: {
    FH: '447893945748',
    PW: '447893945748',
  },
  at: {
    FH: '447893945748',
  },
  us: {
    FH: '447723306490',
    PW: '447723306490',
  },
  nl: {
    FH: '447401164984',
  },
  ca: {
    FH: '447863783096',
  },
  gr: {
    PW: '447360546156',
  },
  pl: {
    PW: '447883277053',
  },
  cz: {
    PW: '447700148090',
  },
  sk: {
    PW: '447412383854',
  },
  it: {
    PW: '447488891505',
  },
  fr: {
    PW: '447462335080',
  },
  be: {
    PW: '447462335080',
  },
};

// FR-3623: Trustpilot "Review Collector" TrustBox, per store (country -> brand).
// data-template-id is the same for every store, so it lives in the component.
const trustpilotDea = {
  businessunitId: '5e4292a1aad52f0001931010',
  borderColor: '#005c69',
};
const trustpilotFanhome = {
  businessunitId: '5fb7fd5f3a4430000138fa6d',
  borderColor: '#581D70',
  locale: 'de-DE',
};
export const trustpilotReview = {
  es: {
    PW: {
      businessunitId: '602f9514724e55000103c04e',
      borderColor: '#005c69',
      locale: 'es-ES',
      token: '9c27e4da-6f26-4901-b83e-05fc2b7a169c',
      url: 'https://es.trustpilot.com/review/planetadeagostini.es',
    },
  },
  fr: {
    PW: {
      businessunitId: '55fa69250000ff0005836652',
      borderColor: '#005c69',
      locale: 'fr-FR',
      token: '062c2675-51b5-4e17-bc44-12d5c56cd639',
      url: 'https://fr.trustpilot.com/review/altaya.fr',
    },
  },
  be: {
    PW: {
      businessunitId: '55fa69250000ff0005836652',
      borderColor: '#005c69',
      locale: 'fr-FR',
      token: '062c2675-51b5-4e17-bc44-12d5c56cd639',
      url: 'https://fr.trustpilot.com/review/altaya.fr',
    },
  },
  it: {
    PW: {
      ...trustpilotDea,
      locale: 'it-IT',
      token: 'b9161b47-1182-46de-af9c-6407d0f6867a',
      url: 'https://it.trustpilot.com/review/www.deagostini.com',
    },
  },
  gr: {
    PW: {
      ...trustpilotDea,
      locale: 'en-US',
      token: '19dfa866-0978-4784-81ef-d43080c6da96',
      url: 'https://www.trustpilot.com/review/www.deagostini.com',
    },
  },
  pl: {
    PW: {
      ...trustpilotDea,
      locale: 'pl-PL',
      token: '370c8f9a-c623-451f-8cbe-bc60ed58868a',
      url: 'https://pl.trustpilot.com/review/www.deagostini.com',
    },
  },
  hu: {
    PW: {
      ...trustpilotDea,
      locale: 'en-US',
      token: '497537a2-24c0-406d-8f4f-57bd53cf6848',
      url: 'https://www.trustpilot.com/review/www.deagostini.com',
    },
  },
  cz: {
    PW: {
      ...trustpilotDea,
      locale: 'en-US',
      token: '497537a2-24c0-406d-8f4f-57bd53cf6848',
      url: 'https://www.trustpilot.com/review/www.deagostini.com',
    },
  },
  sk: {
    PW: {
      ...trustpilotDea,
      locale: 'en-US',
      token: '497537a2-24c0-406d-8f4f-57bd53cf6848',
      url: 'https://www.trustpilot.com/review/www.deagostini.com',
    },
  },
  uk: {
    FH: {
      ...trustpilotFanhome,
      locale: 'en-US',
      token: 'f860a83c-306b-4f5c-98ad-4c150e59c225',
      url: 'https://www.trustpilot.com/review/fanhome.com',
    },
  },
  us: {
    FH: {
      ...trustpilotFanhome,
      locale: 'en-US',
      token: 'f860a83c-306b-4f5c-98ad-4c150e59c225',
      url: 'https://www.trustpilot.com/review/fanhome.com',
    },
  },
  ca: {
    FH: {
      ...trustpilotFanhome,
      locale: 'en-US',
      token: 'f860a83c-306b-4f5c-98ad-4c150e59c225',
      url: 'https://www.trustpilot.com/review/fanhome.com',
    },
  },
  de: {
    FH: {
      ...trustpilotFanhome,
      token: 'aa9ffb4a-9a3c-44eb-8ff0-d7c63b87b326',
      url: 'https://de.trustpilot.com/review/fanhome.com',
    },
  },
  at: {
    FH: {
      ...trustpilotFanhome,
      token: 'aa9ffb4a-9a3c-44eb-8ff0-d7c63b87b326',
      url: 'https://de.trustpilot.com/review/fanhome.com',
    },
  },
  nl: {
    FH: {
      ...trustpilotFanhome,
      locale: 'nl-NL',
      token: '72391e5a-a520-458f-904a-91d82cfb7de4',
      url: 'https://nl.trustpilot.com/review/fanhome.com',
    },
  },
};

export const zendeskSupport = {
  uk: {
    FH: {
      key: '9463728b-9c81-4d32-ae8e-cf970437b1ac',
      timezone: 'Europe/London',
    },
  },
  us: {
    FH: {
      key: '26a2cff2-5640-4e2c-9879-b2cd542b696e',
    },
  },
  de: {
    FH: {
      key: '4a72963f-5923-4597-838b-bc7ff8e94d9a',
      timezone: 'Europe/Berlin',
    },
  },
  gr: {
    PW: {
      key: 'ab800d74-a4aa-4f3e-8611-e81d53fd3f91',
      timezone: 'Europe/Athens',
    },
  },
  nl: {
    FH: {
      key: '9463728b-9c81-4d32-ae8e-cf970437b1ac',
      timezone: 'Europe/Berlin',
    },
  },
  at: {
    FH: {
      key: '4a72963f-5923-4597-838b-bc7ff8e94d9a',
      timezone: 'Europe/Berlin',
    },
  },
};

export const contactReasons = {
  damagedIssue: {
    value: 'damagedIssue',
    zd: 'claims-damaged_parts',
  },
  missingIssue: {
    value: 'missingIssue',
    zd: 'claims-parts_missing/wrong_parts',
  },
  missingParcel: {
    value: 'missingParcel',
    zd: 'claims-missing_delivery',
  },
  other: {
    value: 'other',
    zd: '-',
  },
};

export const zendeskCustomFieldsTest = {
  brand: {
    id: 9622013621393,
  },
  country: {
    id: 9621980886033,
  },
  contactReason: {
    id: 9621963927953,
  },
  universalTitle: {
    id: 10821910855185,
  },
  deaChannel: {
    id: 9621951058961,
  },
};
export const zendeskCustomFields = {
  brand: {
    id: 1900001817493,
  },
  country: {
    id: 360026373537,
  },
  contactReason: {
    id: 360018522278,
  },
  universalTitle: {
    id: 12304910162193,
  },
  deaChannel: {
    id: 360019328038,
  },
};

export const zendeskDeaChannelTest = 'mail_inbound_xxx';
export const zendeskDeaChannel = 'mail_inbound';

export const zendeskAssigneeGroupTest = {
  UK: 9621950363921,
  US: 9621927909265,
  NL: 9622012714513,
  DE: 9622012684049,
  AT: 9621999865233,
  GR: 9622000030865,
  PL: 9621980104849,
  CZ: 9621980104849,
  SK: 9621980104849,
  IT: 17616635714705,
};
export const zendeskAssigneeGroup = {
  UK: 360009955978,
  US: 360007087478,
  NL: 360009966577,
  DE: 5573572593425,
  AT: 5573564735633,
  GR: 360008273738,
  PL: 6349978470545,
  CZ: 19395534590353,
  SK: 19395559780241,
  IT: 19395537891345,
  FR: 24760187411089,
  BE: 24760249688081,
  ES: 24760152440721,
  HU: 43433688868113,
};

export const zendeskTag = 'ca_automatic_missingdamaged';
export const zendeskWithdrawalTag = 'withdrawal';
export const zendeskSubject = '[CA] automatic missing/damaged';

export const zendeskRecipient = {
  IT: {
    PW: 'servizio.clienti@deagostini.it',
  },
  GR: {
    PW: 'customer.service@deagostini.gr',
  },
  CZ: {
    PW: 'zakaznicke.centrum@deagostini.cz',
  },
  SK: {
    PW: 'zakaznicke.centrum@deagostini.sk',
  },
  PL: {
    PW: 'bok@deagostini.pl',
  },
  AT: {
    FH: 'support@at.fanhome.com',
  },
  NL: {
    FH: 'support@nl.fanhome.com',
  },
  CA: {
    FH: 'support@ca.fanhome.com',
  },
  UK: {
    PW: 'support@uk.fanhome.com',
    FH: 'support@uk.fanhome.com',
  },
  US: {
    PW: 'support@usa.fanhome.com',
    FH: 'support@usa.fanhome.com',
  },
  DE: {
    PW: 'support@de.fanhome.com',
    FH: 'support@de.fanhome.com',
  },
  FR: {
    PW: 'gestionclients@altaya.fr',
  },
  BE: {
    PW: 'serviceclientele@altaya.be',
  },
  ES: {
    PW: 'atencionclientes@planetadeagostini.es',
  },
  HU: {
    PW: 'support@deagostini.hu',
  },
};

export const consentsOrder = ['GDPRPromo', 'GDPRProfiling', 'GDPRPromo3rd'];

export const alphaCountryCodes = {
  GBR: 'GB',
  USA: 'US',
  FRA: 'FR',
  DEU: 'DE',
  ITA: 'IT',
  ESP: 'ES',
  PRT: 'PT',
  NLD: 'NL',
  BEL: 'BE',
  LUX: 'LU',
  SWE: 'SE',
  NOR: 'NO',
  DNK: 'DK',
  FIN: 'FI',
  ISL: 'IS',
  IRL: 'IE',
  CHE: 'CH',
  AUT: 'AT',
  POL: 'PL',
  CZE: 'CZ',
  SVK: 'SK',
  HUN: 'HU',
  ROU: 'RO',
  BGR: 'BG',
  GRC: 'GR',
  RUS: 'RU',
  UKR: 'UA',
  TUR: 'TR',
  IND: 'IN',
  CHN: 'CN',
  JPN: 'JP',
  KOR: 'KR',
  AUS: 'AU',
  NZL: 'NZ',
  CAN: 'CA',
  MEX: 'MX',
  BRA: 'BR',
  ARG: 'AR',
  ZAF: 'ZA',
};

export const privacyPolicyLink = {
  uk: 'https://www.fanhome.com/uk/privacy-policy',
  de: 'https://www.fanhome.com/de/datenschutz',
  at: 'https://www.fanhome.com/at/datenschutz',
  nl: 'https://www.fanhome.com/nl/privacyverklaring',
  es: 'https://www.planetadeagostini.es/es/info/politica-privacidad',
  fr: 'https://www.altaya.fr/fr/info/politique-confidentialite',
  be: 'https://www.altaya.be/be/info/politique-confidentialite',
  it: 'https://www.deagostini.com/it/informativa-privacy',
  gr: 'https://www.deagostini.com/gr/politiki-aporritou',
  pl: 'https://www.deagostini.com/pl/polityka-prywatnosci',
  hu: 'https://www.deagostini.com/hu/adatvedelmi-iranyelvek-ugyfelek-szemelyes-adatainak-feldolgozasa',
  sk: 'https://www.deagostini.com/sk/ochrana-osobnych-udajov',
  cz: 'https://www.deagostini.com/cz/ochrana-osobnich-udaju',
};
